import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/Button'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import workoutMessages from 'modules/workout/redux/messages'
import ExerciseHeaderRight from 'pages/Exercise/components/HeaderRight/index.js'

export function ExerciseHeader ({
  isMobileScreen,
  onGoBack,
  isReadOnly,
  isReplacing,
  loading,
  setLoading,
  exerciseId,
  workoutExerciseId,
  navigateBackToOrigin
}) {
  const intl = useIntl()

  return (
    <View
      m={isMobileScreen ? 'unset' : '0 auto'}
      w={isMobileScreen ? 'unset' : '500px'}
      px={1.5}
      row
      py={2}
      style={{
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {/* Back Button */}
      <View style={{ width: '100px' }}>
        <Button
          onClick={onGoBack}
          style={{
            width: 'unset',
            height: 'unset',
            maxWidth: 'unset',
            maxHeight: 'unset'
          }}
        >
          <ArrowDownIcon
            style={{
              width: '18px',
              height: '18px',
              transform: 'rotate(90deg)'
            }}
          />
        </Button>
      </View>

      {/* Title */}
      <Text
        fw='500'
        fs='1.3em'
        style={{ textAlign: 'center' }}
      >
        {formatMessageIntlUtil(intl, workoutMessages.exercise)}
      </Text>

      {/* Right Side Actions */}
      {isReadOnly
        ? (
          <View
            style={{
              width: '100px',
              textAlign: 'end',
              opacity: 0
            }}
          />
          )
        : (
          <ExerciseHeaderRight
            isReplacing={isReplacing}
            loading={loading}
            setLoading={setLoading}
            exerciseId={exerciseId}
            workoutExerciseId={workoutExerciseId}
            navigateBackToOrigin={navigateBackToOrigin}
          />
          )}
    </View>
  )
}

ExerciseHeader.propTypes = {
  isMobileScreen: PropTypes.bool.isRequired,
  onGoBack: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  isReplacing: PropTypes.bool,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  exerciseId: PropTypes.number,
  workoutExerciseId: PropTypes.number,
  navigateBackToOrigin: PropTypes.func
}
